import AuthGuard from '@/guard/auth'
import Navbar from '@/components/menu/Navbar'
import IamGuard from '@/guard/iam'
import { RegistryIdentityContextProvider } from '@/context/registry_identity'
import RegistryIdentityPage from '@/components/pages/RegistryIdentityPage'

function RegistrySession() {
	return (
		<AuthGuard>
			<IamGuard page='admin'>
				<RegistryIdentityContextProvider>
					<div className='relative min-h-screen flex flex-col'>
						<Navbar></Navbar>
						<RegistryIdentityPage></RegistryIdentityPage>
					</div>
				</RegistryIdentityContextProvider>
			</IamGuard>
		</AuthGuard>
	)
}

export default RegistrySession
